
import { currentQueryOptions } from '@/api/memberPermissionsQueryOptions';
import { showStartpageQueryOptions, useUpdateShowStartpageMutation } from '@/api/settingUserOptions';
import LoadProgress from '@/components/LoadProgress';
import BirthdayList from '@/components/panel/BirthdayList';
import RequestsPanel from '@/components/panel/RequestsPanel';
import SelectOrganization from '@/components/SelectOrganization';
import SelectOrganizationAndRole from '@/components/SelectOrganizationAndRole';
import { getMember, getOrganization } from '@/store/auth/authSlice';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, styled, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useFlag } from '@unleash/proxy-client-react';
import { t } from 'i18next';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';
export const Route = createFileRoute('/_auth/start')({
    component: OverviewPage,
})

const Spacer = styled('div')(() => ({
    position: 'relative',
    height: '30px',
}));

function OverviewPage() {

    const storage = sessionStorage

    const auth = useAuth()

    const accessKey = storage.getItem('AccessKey')
    const member = useSelector(getMember);
    const sessionOrganization = useSelector(getOrganization)

    const showStartpageQuery = useSuspenseQuery(showStartpageQueryOptions())
    const showStartpage = showStartpageQuery.data as unknown as boolean

    const updateShowStartpage = useUpdateShowStartpageMutation()

    const permissionsQuery = useSuspenseQuery(currentQueryOptions())
    const permissions = permissionsQuery.data;

    const scoreg_core_features = useFlag('scoreg_core_features');

    const navigate = useNavigate()

    if (showStartpageQuery.isLoading || showStartpageQuery.isFetching) {
        return <LoadProgress />
    }
    if (permissionsQuery.isLoading || permissionsQuery.isFetching) {
        return <LoadProgress />
    } else if (permissions.length == 0) {
        return (
            <>
                <div>Keine Berechtigungen vorhanden</div>
                <p>Benutzer: {auth.user?.profile.preferred_username}</p>
                <p>Vorname: {auth.user?.profile.given_name}</p>
                <p>Nachname: {auth.user?.profile.family_name}</p>
                <p>E-Mail: {auth.user?.profile.email}</p>
            </>
        )
    }

    if (accessKey && sessionOrganization) {
        return (
            <>
                <div className="p-2">
                    <h3>{t('label.index.welcome')} {member?.firstname}!</h3>
                </div>
                <RequestsPanel />
                <BirthdayList />
                <FormControlLabel control={
                    <Checkbox checked={showStartpage} onChange={(e) => {
                        if (e.target.checked) {
                            updateShowStartpage.mutate('true')
                        } else {
                            updateShowStartpage.mutate('false')
                            navigate({
                                to: '/membershipsOverview',
                                search: {
                                    filter: [
                                        { field: "active", operator: "is", value: "true" },
                                        { field: "organization.uuid", operator: "isAnyOf", value: [sessionOrganization.uuid] },
                                        { field: "scoutstate", operator: "isAnyOf", value: ['MEMBER_FULL', 'MEMBER_ADD'] }
                                    ],
                                    sort: [{ field: "member.scoutId", direction: "asc" }],
                                    visibility: [{ field: "properties.joblist" }, { field: "properties.section" }],
                                }
                            })
                        }
                    }} />} label="diese Startseite nach dem Login anzeigen" />
                {showStartpage}
            </>
        )
    } else {
        return (
            <div className="p-2">
                <h4>{t('label.index.selectOrganization')}</h4>
                {scoreg_core_features && <>
                    Zugewiesene Organisationen:
                </>}
                <SelectOrganization />

                {scoreg_core_features && <>
                    <Spacer />
                    <Accordion disableGutters elevation={0} square>
                        <AccordionSummary
                            expandIcon={<ArrowDownwardIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography component="span">Erweiterte Optionen (ROOT)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <SelectOrganizationAndRole />
                        </AccordionDetails>
                    </Accordion>
                </>}
            </div>
        )
    }
}
